import React from 'react';
import { arrayOf, shape, number } from 'prop-types';

import MenuItem from '../MenuItem';

const Menu = ({ list, selected }) =>
  list.map((item, index) => {
    const { title, image } = item;

    return (
      <MenuItem
        title={title}
        image={image}
        // eslint-disable-next-line react/no-array-index-key
        key={index}
        selected={selected === index}
      />
    );
  });

Menu.propTypes = {
  list: arrayOf(shape({})).isRequired,
  selected: number.isRequired
};

export default Menu;
